<h1 mat-dialog-title>{{'Are you sure?' | translate}}</h1>
<div mat-dialog-content>
    <p>
        {{'Do you want confirm?' | translate}}
    </p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="confirm()">{{'Yes' | translate}}</button>
    <button mat-raised-button color="primary" (click)="cancel()">{{'No' | translate}}</button>
</div>